import { getMobileOperatingSystem } from './utils';
import Connector from './native/prototype';

// eslint-disable-next-line
let connector = new Connector();

const system = getMobileOperatingSystem();

switch (system) {
  case 'android':
    // eslint-disable-next-line
    connector = require('./native/android').default;
    break;
  case 'ios':
    // eslint-disable-next-line
    connector = require('./native/ios').default;
    break;
  default:
    break;
}

export default connector;



// WEBPACK FOOTER //
// ./src/common/js/nativeInterface.js